"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _pagerButton = _interopRequireDefault(require("../../core/pager-button"));
var _userIsSystemAdmin = _interopRequireDefault(require("../../../schema/security/user-is-system-admin"));
var _requireAuthentication = _interopRequireDefault(require("../../require-authentication"));
var _constantParams = require("../../../constant-params");
var _defaultTiers = _interopRequireDefault(require("./default-tiers"));
var _alert = _interopRequireDefault(require("../../core/alert"));
var _helpButton = _interopRequireDefault(require("../../core/help-button"));
var _defaultTiersHelp = _interopRequireDefault(require("./default-tiers-help"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _ref = /*#__PURE__*/_react.default.createElement("br", null);
var _ref2 = /*#__PURE__*/_react.default.createElement("br", null);
var _ref3 = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "warning"
}, /*#__PURE__*/_react.default.createElement("p", null, "Changes to values on this page, including adjustments to entry fees, will not change any existing Competitions, but will be used when creating new competitions. They are also used to compare with actual competition fees to identify those with enhanced fees.")));
var _ref4 = /*#__PURE__*/_react.default.createElement(_helpButton.default, null, /*#__PURE__*/_react.default.createElement(_defaultTiersHelp.default, null));
function Tiers({
  isAuthenticated,
  user,
  loaded,
  match: {
    url,
    path,
    params
  }
}) {
  const currentYear = +params.yearID;
  const previousYear = currentYear - 1;
  const previousYearURL = path.replace(`year/:yearID`, `year/${previousYear}`);
  const nextYear = currentYear + 1;
  const nextYearURL = path.replace(`year/:yearID`, `year/${nextYear}`);
  return /*#__PURE__*/_react.default.createElement("div", null, !isAuthenticated || !(0, _userIsSystemAdmin.default)(user) ? 'You do not have access to this page' : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "span"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pull-xs-left"
  }, previousYear < 2020 ? null : /*#__PURE__*/_react.default.createElement(_pagerButton.default, {
    to: previousYearURL
  }, "Previous Year ", previousYear)), /*#__PURE__*/_react.default.createElement("div", {
    className: "pull-xs-right"
  }, nextYear > _constantParams.thisYear + 1 ? null : /*#__PURE__*/_react.default.createElement(_pagerButton.default, {
    to: nextYearURL
  }, "Next Year ", nextYear))), _ref, _ref2, _ref3, _ref4, /*#__PURE__*/_react.default.createElement(_defaultTiers.default, {
    yearID: currentYear
  })));
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = (0, _requireAuthentication.default)(Tiers);